import { render, staticRenderFns } from "./observacao.vue?vue&type=template&id=4fe56e94&"
import script from "./observacao.vue?vue&type=script&lang=js&"
export * from "./observacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports